import type {
  RefundCreateRequestType,
  RefundCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRefundCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      data,
      idempotencyKey,
    }: {
      data: RefundCreateRequestType;
      idempotencyKey: string;
    }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `refunds`,
        data,
        idempotencyKey,
      }).then(
        (data) => apiV2AssertResponse(data).data as RefundCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Refunds],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.OrdersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Refunds,
          response.id,
        ],
      });
    },
  });
};
